import { Stack, Title } from '@mantine/core';

import { Declaration } from '@e-origin/shared';

import { FieldRow, PolicyField, useFinalizeFieldRules } from '../policy';

const DELIVERY_TERMS = 'chargesDeliveryTerms';
const CUSTOMS_CHARGES = 'valuationInformationTaxes.chargesimport.CustomsCharges.charges';
const CUSTOMS_CURRENCY = 'valuationInformationTaxes.chargesimport.CustomsCharges.currency';
const VAT_CHARGES = 'valuationInformationTaxes.chargesimport.VATcharges.charges';
const VAT_CURRENCY = 'valuationInformationTaxes.chargesimport.VATcharges.currency';

interface ChargesImportSectionProps {
  declaration: Declaration;
}

export const ChargesImportSection: React.FC<ChargesImportSectionProps> = ({ declaration }) => {
  const { rule, fieldProps } = useFinalizeFieldRules();

  if (!rule(CUSTOMS_CHARGES).present) {
    return null;
  }

  return (
    <Stack>
      <Title order={4}>Charges import</Title>

      <FieldRow mb="sm">
        <PolicyField
          {...fieldProps(DELIVERY_TERMS)}
          span={12}
          value={declaration.valuationInformationTaxes?.deliveryTerms?.incotermCode}
          eucdmPath={'valuationInformationTaxes.deliveryTerms.incotermCode'}
        />
      </FieldRow>

      <FieldRow mb="sm">
        <PolicyField {...fieldProps(CUSTOMS_CHARGES)} span={6} eucdmPath={'valuationInformationTaxes.globalChargesimport.CustomsCharges.charges'} />
        <PolicyField {...fieldProps(CUSTOMS_CURRENCY)} span={6} />
      </FieldRow>

      <FieldRow mb="sm">
        <PolicyField {...fieldProps(VAT_CHARGES)} span={6} eucdmPath={'valuationInformationTaxes.globalChargesimport.VATcharges.charges'} />
        <PolicyField {...fieldProps(VAT_CURRENCY)} span={6} />
      </FieldRow>
    </Stack>
  );
};
